var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createSelector } from 'reselect';
import { initialState } from './reducer';
export var selectManagedOrgDevPlanDomain = function (state) {
    return state.managedOrgDevPlan || initialState;
};
var selectDeveloperPlans = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).developerPlans;
};
export var selectDeveloperPlansOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).developerPlansOrg;
};
export var selectDeveloperPlanStatusLoading = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).devPlanStatus_loading;
};
export var selectDeveloperPlanStatus = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).devPlanStatus;
};
export var selectDevPlanStatusOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).devPlanStatusOrg;
};
export var selectDevPlanInvoiceDetails = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).devPlanInvoiceDetails;
};
export var selectDevPlanInvoiceDetailsOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).devPlanInvoiceDetailsOrg;
};
var selectDeveloperPlanConsume = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).devPlanConsume;
};
export var selectDeveloperPlanConsumeOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).devPlanConsumeOrg;
};
export var selectDevPlanStatus = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).devPlanStatus;
};
export var selectDevPlanBundles = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).bundles;
};
export var selectDevPlanBundlesOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).bundlesOrg;
};
export var selectActiveBundles = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).activeBundles;
};
export var selectActiveBundlesOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).activeBundlesOrg;
};
export var selectUpdatedAddons = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).updatedAddons;
};
export var selectProRatedAmount = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).proRatedAmount;
};
export var selectProRatedAmountLoading = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).proRatedAmount_loading;
};
export var selectProRatedAmountError = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).proRatedAmount_error;
};
export var selectPurchaseDevPlanBundleLoading = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).purchase_dev_plan_bundle_loading;
};
export var selectPurchaseDevPlanBundleError = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).purchase_dev_plan_bundle_error;
};
export var selectProratedAmountForAddons = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.managedOrgDevPlan) || initialState).proratedAmountForAddons;
};
export var makeSelectActiveDeveloperPlan = createSelector(selectDeveloperPlans, function (devPlans) {
    return (devPlans === null || devPlans === void 0 ? void 0 : devPlans.find(function (plan) { return plan.active_dev_plan; })) || {};
});
export var makeSelectDeveloperPlanConsume = createSelector(selectDeveloperPlanConsume, function (devPlanConsume) { return devPlanConsume; });
export var makeSelectDeveloperPlanStatus = createSelector(selectDevPlanStatus, function (devPlanStatus) { return devPlanStatus || {}; });
export var makeSelectActiveBundles = createSelector(selectActiveBundles, function (activeBundles) { return activeBundles; });
export var selectFilteredDevPlans = createSelector(selectManagedOrgDevPlanDomain, function (plans) {
    var _a;
    var plan = (_a = plans.developerPlans) === null || _a === void 0 ? void 0 : _a.filter(function (e) { return e['interval'] === plans.interval; });
    var orderedDevPlans = __spreadArray(__spreadArray([], (plan || []).filter(function (e) { return e.active_dev_plan; }), true), (plan || []).filter(function (e) { return !e.active_dev_plan; }), true);
    return orderedDevPlans;
});
export var makeSelectDevPlanInterval = createSelector(selectManagedOrgDevPlanDomain, function (devPlanDetails) { return devPlanDetails === null || devPlanDetails === void 0 ? void 0 : devPlanDetails.interval; });
export var makeSelectDevPlans = createSelector(selectManagedOrgDevPlanDomain, function (substate) {
    return substate;
});
